export const CAPITAL_EXPLORER = "capitalExplorer";
export const CAPITAL_EXPLORER_COMPARISON_TABLE =
  "capitalExplorerComparisonTable";
export const CAPITAL_EXPLORER_VISITORS_VIEW = "capitalExplorer.visitorsView";
